import React from "react";
import {
  MDSListBoxItem,
  MDSListBoxItemProps,
  MDSListBoxSlotName,
} from "@/mds/components/lists/list-box-item";
import {
  StyledHeader,
  StyledListBox,
  StyledLeftAddon,
  StyledRightAddon,
} from "@/mds/components/lists/list-box/list-box.style";
import { MDSListBoxProps } from "@/mds/components/lists/list-box/list-box.types";
import { MDSTextVariant } from "@/mds/components/text";

export const MDSListBox = React.forwardRef<HTMLDivElement, MDSListBoxProps>(
  ({ items, label, children, ...props }, ref) => {
    // Use aria-label from props if provided, otherwise fall back to label
    const ariaLabel = props["aria-label"] || label;

    if (!items && children) {
      // static list box
      return (
        <>
          {label && <StyledHeader variant={MDSTextVariant.HeaderS}>{label}</StyledHeader>}
          <StyledListBox {...props} ref={ref} aria-label={ariaLabel}>
            {children}
          </StyledListBox>
        </>
      );
    }

    // dynamic list box
    return (
      <>
        {label && <StyledHeader variant={MDSTextVariant.HeaderS}>{label}</StyledHeader>}
        <StyledListBox
          {...props}
          ref={ref}
          items={items as MDSListBoxItemProps[]}
          aria-label={ariaLabel}
        >
          {item => (
            <MDSListBoxItem key={item.id} {...item}>
              {item.leftAddon && (
                <StyledLeftAddon slot={MDSListBoxSlotName.LeftAddon}>
                  {item.leftAddon}
                </StyledLeftAddon>
              )}
              {item.children}
              {item.rightAddon && (
                <StyledRightAddon slot={MDSListBoxSlotName.RightAddon}>
                  {item.rightAddon}
                </StyledRightAddon>
              )}
            </MDSListBoxItem>
          )}
        </StyledListBox>
      </>
    );
  }
);

MDSListBox.displayName = "MDSListBox";
